import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getGrupoFisicoList } from './selectdbAtions';
// Removido: import { getConfig, setConfig } from '../../configuracao/configLocal';
// Removido: import { getConfControladorGrupoList } from './selectdbAtions';

import './contentHeaderFilter.css';

class SelectGrupoFisicoParaTicket extends Component {
  componentDidMount() {
    this.props.getGrupoFisicoList();
  }

  renderOptions() {
    const list = this.props.list || [];

    if (list.length === 0) {
      return <option value="">Carregando...</option>;
    }

    return list.map(grupo => (
      <option key={grupo.id} value={grupo.id}>
        {grupo.id} - {grupo.descricao}
      </option>
    ));
  }

  handleChange(event) {
    if (this.props.onChange) {
      this.props.onChange(event.target.value);
    }
  }

  render() {
    return (
      <div style={{ marginTop: '5px' }}>
        <label style={{ display: 'inline' }} htmlFor={'selectGrupoFisicoTicket'}>
          <small>Grupo Físico: </small>
        </label>
        <select
          id={'selectGrupoFisicoTicket'}
          name={'selectGrupoFisicoTicket'}
          style={{ width: '160px', display: 'inline' }}
          className={'form-control'}
          onChange={event => this.handleChange(event)}
          value={this.props.value || ''} // Controlado pelo componente pai
        >
          <option value="">{this.props.emptyText || 'Selecione...'}</option>
          {this.renderOptions()}
        </select>
      </div>
    );
  }
}

const mapStateToProps = state => ({ list: state.grupoFisicoCad.list });
const mapDispatchToProps = dispatch => bindActionCreators({ getGrupoFisicoList }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectGrupoFisicoParaTicket);
